import React from 'react';
import fccLogo from '../home/assets/fcc_logo_anime.png';
import './lazy_anime.css';
const Lazyanime = () => {
      return ( 
           <div className="content-slideshow">
                 <div className="col-md-5">
                        <div className="d-flex flex-wrap justify-content-center">
                            <div className="c-carousel">
       
                                   <img className="loading-text image-loading" src={fccLogo} alt="Faithword" />      
                            </div>
                       </div>
                       <div>
                       <h6 className="loading-text text-light text-center mt-2">Raising a People of Excellence</h6>

                       </div>
                       
                      
                  </div> 
           </div>
       );
}
 
export default Lazyanime;